<template>
    <v-tooltip-wrapper :open-delay="350">
        <template #activator="{ on, attrs }">
            <div :class="containerClasses"
                 class="element-icon-outer-container"
                 v-bind="$attrs"
                 v-on="$listeners">
                <div :class="innerContainerClasses"
                     class="element-icon-container-gap"
                     v-bind="attrs"
                     v-on="on">

                    <eicon v-bind="eIconProps" />

                    <i v-if="linkStateIcon"
                       :class="linkStateIconClasses"
                       class="fas element-icon-link-state" />
                </div>

                <slot />

            </div>
        </template>

        <div class="icon-in-tooltip-column-container">
            <div class="icon-in-tooltip-container">
                <eicon class="icon-in-tooltip"
                       v-bind="eIconProps" />
                {{ title }}
            </div>
            <div v-if="linkStateIcon"
                 class="icon-in-tooltip-container">
                <i :class="linkStateIconClasses"
                   class="fas icon-in-tooltip element-icon-link-state" />
                {{ linkStateText }}
            </div>
        </div>
    </v-tooltip-wrapper>
</template>

<script>
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'
import {getIconType, getTitle} from "./utility";

export default {
    components: { VTooltipWrapper },
    inheritAttrs: false,
    inject: {
        /** @type {PublishInjectInfoTable} */
        publishInfoTable: {
            default: {}
        },
        /** @type {PublishInjectInfoRaw} */
        publishInfoRaw: {
            default: {}
        }
    },
    props: {
        /*/!** @type {PublishElementData} *!/*/
        /** @type {PublishElementDataCommon} */
        data: Object,
        active: Boolean,
        containerClasses: Array,
        innerContainerClasses: Array
    },
    data() {
        return {
            t_linked: Lang.langGet('Element linked to the original'),
            t_unlinked: Lang.langGet('Element unlinked from the original')
        }
    },
    computed: {
        kind() {
            return getIconType(this.dataComputed.type, this.dataComputed.dynamic);
        },
        title() {
            return getTitle(this.kind);
        },
        eIconProps() {
            return {
                'font-color': this.active,
                'kind': this.kind
            }
        },
        linkStateIcon() {
            return !this.dataComputed.inline && this.dataComputed.state && (['link', 'copy'].includes(this.dataComputed.state));
        },
        linkStateIconClasses() {
            return {
                'fa-link-simple': this.dataComputed.state == 'link',
                'fa-link-simple-slash': this.dataComputed.state == 'copy'
            }
        },
        linkStateText() {
            switch (this.dataComputed.state) {
                case 'link':
                    return this.t_linked
                case 'copy':
                    return this.t_unlinked
                default:
                    return null
            }
        },
        dataComputed() {
            return this.data ?? this.publishInfoTable?.element?.data ?? this.publishInfoRaw?.element?.data
        }
    }
}
</script>

<style>
.element-icon-container-gap,
.element-icon-outer-container {
    display: inline-flex;
    align-items: center;

    line-height: 0;
}

.element-icon-container-gap {
    gap: var(--gap-element-icon);
}

.element-icon-link-state {
    color: color-mix(in srgb, var(--color-eicon-original) 68%, transparent);
}
</style>
